export const HEAD_ROW_CATEGORY_KEY = 'base' as const;
export const HEAD_ROW_PARENT_COMPONENT_KEY = 'table' as const;
export const HEAD_ROW_COMPONENT_KEY = 'headRow' as const;
